export const formatMoney = (value) => {
    const num = Number(value || 0);
    return num.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
};

export const getAgreementStatusLabel = (status) => {
    const labels = {
        bozza: 'Bozza',
        confermato: 'Confermato',
        inviato_amministrazione: 'In amministrazione',
        fatturato: 'Fatturato',
        annullato: 'Annullato',
        in_migrazione: 'In migrazione',
    };
    return labels[status] || status;
};

export const getAgreementStatusColor = (status) => {
    const colors = {
        bozza: 'default',
        confermato: 'processing',
        inviato_amministrazione: 'warning',
        fatturato: 'success',
        annullato: 'error',
        in_migrazione: 'purple',
    };
    return colors[status] || 'default';
};

export const getMigrationStatusLabel = (status) => {
    const labels = {
        in_corso: 'In corso',
        completata: 'Completata',
        annullata: 'Annullata',
    };
    return labels[status] || status;
};

export const getMigrationStatusColor = (status) => {
    const colors = {
        in_corso: 'processing',
        completata: 'success',
        annullata: 'error',
    };
    return colors[status] || 'default';
};

export const getDealTypeLabel = (dealType) => {
    const labels = {
        privato: 'Privato',
        asl: 'ASL / SSN',
        assicurazione: 'Assicurazione',
    };
    return labels[dealType] || dealType;
};

export const getDealTypeColor = (dealType) => {
    const colors = {
        privato: 'blue',
        asl: 'green',
        assicurazione: 'purple',
    };
    return colors[dealType] || 'default';
};

export const getQueueStatusLabel = (status) => {
    const labels = {
        in_attesa: 'In attesa',
        lavorazione: 'In lavorazione',
        completato: 'Completato',
        bloccato: 'Bloccato',
    };
    return labels[status] || status;
};

export const getQueueStatusColor = (status) => {
    const colors = {
        in_attesa: 'default',
        lavorazione: 'processing',
        completato: 'success',
        bloccato: 'error',
    };
    return colors[status] || 'default';
};

export const getActiveCreditNoteStatusLabel = (status) => {
    const labels = {
        bozza: 'Bozza',
        emessa: 'Emessa',
        chiusa: 'Chiusa',
    };
    return labels[status] || status;
};

export const getActiveCreditNoteStatusColor = (status) => {
    const colors = {
        bozza: 'default',
        emessa: 'warning',
        chiusa: 'success',
    };
    return colors[status] || 'default';
};

export const getReceiptStatusLabel = (status) => {
    const labels = {
        bozza: 'Bozza',
        emesso: 'Emesso',
        annullato: 'Annullato',
    };
    return labels[status] || status;
};

export const getReceiptStatusColor = (status) => {
    const colors = {
        bozza: 'default',
        emesso: 'success',
        annullato: 'error',
    };
    return colors[status] || 'default';
};

export const getReceiptTypeLabel = (receiptType) => {
    const labels = {
        smart_receipt: 'Scontrino telematico',
        vendita_banco: 'Vendita al banco',
    };
    return labels[receiptType] || receiptType;
};

export const getReceiptTypeColor = (receiptType) => {
    const colors = {
        smart_receipt: 'blue',
        vendita_banco: 'orange',
    };
    return colors[receiptType] || 'default';
};

export const getSdiTransmissionStatusLabel = (status) => {
    const labels = {
        pending: 'In attesa trasmissione',
        transmitted: 'Trasmesso',
        error: 'Errore trasmissione',
        not_required: 'Non richiesto',
    };
    return labels[status] || status;
};

export const getSdiTransmissionStatusColor = (status) => {
    const colors = {
        pending: 'processing',
        transmitted: 'success',
        error: 'error',
        not_required: 'default',
    };
    return colors[status] || 'default';
};

export const getPaymentMethodLabel = (method) => {
    const labels = {
        contanti: 'Contanti',
        bonifico: 'Bonifico',
        pos: 'POS / Carta',
        rateizzazione: 'Rateizzazione',
        finanziamento: 'Finanziamento',
    };
    return labels[method] || method;
};

export const recalculateActiveWorkspace = (workspace) => {
    if (!workspace) return workspace;

    const agreements = workspace.agreements || [];
    const queue = workspace.operativeQueue || [];
    const creditNotes = workspace.creditNotes || [];
    const reInvoices = workspace.reInvoices || [];
    const receipts = workspace.receipts || [];

    const agreementsSummary = {
        total: agreements.length,
        confirmed: agreements.filter((a) => a.status === 'confermato').length,
        pendingAdmin: agreements.filter((a) => a.status === 'inviato_amministrazione').length,
        invoiced: agreements.filter((a) => a.status === 'fatturato').length,
    };

    const queueSummary = {
        total: queue.length,
        pending: queue.filter((q) => q.status === 'in_attesa').length,
        inProgress: queue.filter((q) => q.status === 'lavorazione').length,
        blocked: queue.filter((q) => q.status === 'bloccato').length,
    };

    const creditNotesSummary = {
        total: creditNotes.length,
        emitted: creditNotes.filter((cn) => cn.status === 'emessa').length,
        totalAmount: creditNotes.reduce((sum, cn) => sum + Number(cn.total || 0), 0),
    };

    const emittedReceipts = receipts.filter((r) => r.status === 'emesso');
    const receiptsSummary = {
        total: receipts.length,
        emitted: emittedReceipts.length,
        cancelled: receipts.filter((r) => r.status === 'annullato').length,
        smartReceipts: receipts.filter((r) => r.receiptType === 'smart_receipt').length,
        venditeBanco: receipts.filter((r) => r.receiptType === 'vendita_banco').length,
        pendingTransmission: receipts.filter(
            (r) => r.status === 'emesso' && r.sdiTransmission?.status === 'pending'
        ).length,
        totalAmount: emittedReceipts.reduce((sum, r) => sum + Number(r.total || 0), 0),
    };

    return {
        ...workspace,
        summary: {
            agreementsSummary,
            queueSummary,
            creditNotesSummary,
            receiptsSummary,
            reInvoicesTotal: reInvoices.filter((ri) => ri.status === 'emessa').length,
        },
    };
};
